/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SubQuestionIcon
 */
export default class SubQuestionIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M5.94 2c.6 0 1.055.397 1.055.997V14c0 1.7 1.288 3 2.988 3H16.6l-2.3-2.3c-.4-.4-.4-1 0-1.4.2-.2.4-.3.7-.3.3 0 .5.1.7.3l4 4c.1.1.164.197.2.3.036.103.078.243.075.392-.004.13-.033.3-.075.408-.042.108-.1.2-.2.3l-4 4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.3-2.3H9.983c-2.8 0-4.964-2.2-4.964-5V2.997c0-.6.322-.997.922-.997z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

